"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var Arrow = function (_a) {
    var _b = _a.arrowColor, arrowColor = _b === void 0 ? helios_styles_1.icon.strong : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: className, width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.52868 3.61213C7.78903 3.35178 8.21114 3.35178 8.47149 3.61213L13.1382 8.2788C13.3985 8.53915 13.3985 8.96126 13.1382 9.22161L8.47149 13.8883C8.21114 14.1486 7.78903 14.1486 7.52868 13.8883C7.26833 13.6279 7.26833 13.2058 7.52868 12.9455L11.0573 9.41687H3.33341C2.96522 9.41687 2.66675 9.11839 2.66675 8.7502C2.66675 8.38201 2.96522 8.08354 3.33341 8.08354H11.0573L7.52868 4.55494C7.26833 4.29459 7.26833 3.87248 7.52868 3.61213Z", fill: arrowColor }) })));
};
exports.Arrow = Arrow;
